import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';
import {TranslateService} from '@ngx-translate/core';
import {PagesService} from '../../../providers/services/pages.service';
import {Subscription} from 'rxjs';
import {Paths, StaticPage, StaticPageContent} from '../../../../config/config';
import {LocalizeRouterService} from '@gilsdav/ngx-translate-router';
import {UtilsService} from '../../../providers/services/utils.service';

@Component({
  selector: 'app-homepage-catalog',
  templateUrl: './homepage-catalog.component.html',
  styleUrls: ['./homepage-catalog.component.scss']
})
export class HomepageCatalogComponent implements OnInit, OnDestroy {

  items = [];

  @ViewChild(SwiperDirective, {static: false}) swiperInstance: SwiperDirective;
  private readonly subscriptions: Subscription = new Subscription();

  public readonly config: SwiperConfigInterface = {
    autoplay: false,
    loop: false,
    freeMode: true,
    spaceBetween: 0,
    breakpointsInverse: true,
    navigation: false,
    slidesPerView: 1,
    mousewheel: false,
    breakpoints: {
      768: {
        breakpointsInverse: true,
        pagination: false,
        freeMode: false,
        slidesPerView: 2,
        centeredSlides: false
      },
      992: {
        breakpointsInverse: true,
        slidesPerView: 2,
        freeMode: false,
        pagination: false
      }
    }
  };

  constructor(private translationService: TranslateService, private pagesService: PagesService, private routerService: LocalizeRouterService, private utilsService: UtilsService) {
    this.subscriptions.add(
      this.pagesService.getPage(StaticPage.Homepage).subscribe(({body}) => {
        if (body) {
          this.setItems(body.data.contents);
          this.swiperInstance.update();
        }
      })
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private setItems = (body) => {
    const staticPageContent = StaticPageContent[StaticPage.Homepage];
    this.items = [
      {
        image: body[staticPageContent.kit].image.path,
        subTitle: body[staticPageContent.kit].subtitle,
        text: body[staticPageContent.kit].content,
        color: '#171B26',
        title: body[staticPageContent.kit].title,
        url: {
          path: this.routerService.translateRoute(this.utilsService.getLink(Paths.Products)),
          fragment: this.translationService.instant('label_fragment_kit')
        }
      },
      {
        image: body[staticPageContent.accessories].image.path,
        subTitle: body[staticPageContent.accessories].subtitle,
        text: body[staticPageContent.accessories].content,
        color: '#eaeaea',
        title: body[staticPageContent.accessories].title,
        url: {
          path: this.routerService.translateRoute(this.utilsService.getLink(Paths.Products)),
          fragment: this.translationService.instant('label_fragment_accessories')
        }
      },
    ];
  };

}
